import React from 'react';

function LoadingScreen() {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '100vh', flexDirection: 'column', gap: '12px'
    }}>
      <div style={{ fontSize: '24px', fontWeight: '600' }}>RAAH Portal</div>
      <div style={{ color: '#666' }}>Loading...</div>
    </div>
  );
}

export default LoadingScreen;
